import { PublicClientApplication } from '@azure/msal-browser';
import { logger } from '@/common/services/config';

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
// Meilleure détection : vérifier si on est vraiment dans l'app native
const isCapacitorApp = !!(window as any).Capacitor?.isNativePlatform?.();
// Pour le web (même sur mobile), utiliser toujours l'URI desktop
const redirectUri =
  isCapacitorApp && isMobile
    ? import.meta.env.VITE_MSAL_MOBILE_REDIRECT_URI
    : import.meta.env.VITE_MSAL_DESKTOP_REDIRECT_URI;

const getCacheLocation = (): 'localStorage' | 'sessionStorage' | 'memoryStorage' => {
  // Use localStorage to share MSAL cache across tabs and enable SSO
  return 'localStorage';
};

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    authority: import.meta.env.VITE_MSAL_AUTHORITY,
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: !(isCapacitorApp && isMobile), // true for desktop web, false for mobile WebView
    knownAuthorities: [], // Explicitly set empty to avoid cookie caching
  },
  cache: {
    cacheLocation: getCacheLocation(),
    storeAuthStateInCookie: true, // Required for SSO across applications
    secureCookies: window.location.protocol === 'https:', // Secure cookies in HTTPS only (not in localdev HTTP)
    claimsBasedCachingEnabled: true, // Enable claims-based caching for SSO
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: string, containsPii: boolean) => {
        if (containsPii) return;
        logger.log(`MSAL [${level}]: ${message}`);
      },
      piiLoggingEnabled: false,
      logLevel: 1, // Error level
    },
    allowNativeBroker: false, // Disable native broker for WebView
    windowHashTimeout: 10000, // Increased timeout for mobile
    iframeHashTimeout: 10000,
    loadFrameTimeout: 10000, // Additional timeout setting
    navigateFrameWait: 500, // Reduce frame wait time
    asyncPopups: false, // Disable async popups that might use cookies
  },
  telemetry: {
    application: {
      appName: 'EmnVerse',
      appVersion: '1.0.0',
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
